<template>
  <div>
    <h2>403 Forbidden</h2>
    <p>
      It looks like you do not have access to this URL.
      If you believe this is an error, send us a note with the URL you
      are trying to access to our <a href="https://www.donedone.com/help-center">Support Center</a>.
    </p>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'Forbidden',
})
</script>
